import { makeStyles } from 'tss-react/mui';
import { themeColors, themeLayout } from 'app/shared/theme/theme';

export const useStyles = makeStyles()(theme => ({
  header: {
    padding: '8px 11px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${themeColors.greyscale4}`,
  },
  headerClickable: {
    padding: '8px 11px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    borderBottom: `1px solid ${themeColors.greyscale4}`,
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    display: 'flex',

    [theme.breakpoints.down(themeLayout.mobileWidth)]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up(themeLayout.mobileWidth)]: {
      flexDirection: 'row',
    },
  },
  arrowContainer: {
    width: 24,
    borderLeft: `2px solid ${themeColors.greyscale4}`,
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
  expandIcon: {
    width: 22,
    marginRight: '-8px',
    color: themeColors.mbsBlue,
    cursor: 'pointer',
  },
  paddingContainer: {
    padding: '0px 6px',
  },
  noteContainer: {
    padding: 11,
    borderBottom: `1px solid ${themeColors.greyscale4}`,
  },
}));
